import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";

import {
  getTransactionVendorPaymentDetails,
  getTransactionBillPaymentPayeeAddress,
  getTransactionJPMorganDetails,
} from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";

import BillPaymentApply from "./bill-payment/apply";
import BillPaymentRelationship from "./bill-payment/relationships";
import BillPaymentCommunication from "./bill-payment/communication";
import BillPaymentSystemInformation from "./bill-payment/system-information";
import BillPaymentCustom from "./bill-payment/custom";
import BillPaymentEft from "./bill-payment/eft";

export default function TransactionTypeBillPayment() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();

  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  const [rowData, setRowData] = useState([]);
  const [payeeAddData, setPayeeAddData] = useState([]);
  const [jpMorganData, setJpMorganData] = useState([]);
  const [loading, setLoading] = useState(false);

  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
  const [subTabIndex, setSubTabIndex] = useState(0);

  useEffect(() => {
    if (user.token) {
      getTransactionDocBillPaymentDetailsData();
      getTransactionDocBillPaymentPayeeAddData();
      getJPMorganEftData();
    }
  }, []);

  async function getJPMorganEftData(limit = 10, offset = 0) {
    try {
      const { data } = await getTransactionJPMorganDetails(user.token, {
        tranid: params.docNo,
        limit,
        offset,
      });
      setJpMorganData(data.data.details[0]);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }
  async function getTransactionDocBillPaymentDetailsData() {
    setLoading(true);
    try {
      const { data } = await getTransactionVendorPaymentDetails(user.token, {
        tranid: params.docNo,
      });
      setRowData(data.data.details[0]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  async function getTransactionDocBillPaymentPayeeAddData() {
    try {
      const { data } = await getTransactionBillPaymentPayeeAddress(user.token, {
        id: params.docNo,
      });
      setPayeeAddData(data.data.data[0]);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  return loading ? (
    <>
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Bill Payment
      </Typography>
     
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
         
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Bill Payment
      </Typography>

      <Typography component="h5" style={{ marginBottom: "5px" }}>
      <span className="para-no" style={{ marginBottom: "5px" }}>
          {rowData?.payee}
        </span>{" "}
      {  rowData?.status &&   <Button className="blue-button" size="small">
          {rowData?.status} 
        </Button>}
      </Typography>

      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((d, i) => ( */}
          <>
            <Grid container className="mb-2">
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">TRANSACTION NUMBER</p>
                <p className="tFormName">{rowData?.transaction_number}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">AMOUNT</p>
                <p className="tFormName">{rowData?.amount}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">POSTING PERIOD</p>
                <p className="tFormName">{rowData?.posting_period}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">ACCOUNT</p>
                <p className="tFormName">{rowData?.account}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">CURRENCY</p>
                <p className="tFormName">{rowData?.currency}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <Grid container>
                  <Grid item xs={12} sm={6} md={6}>
                    <p className="tFormlabel checkAndTextAlign">
                      {rowData?.to_be_printed === "T" ? (
                        <>
                          <FormGroup>
                            <FormControlLabel
                              control={<Checkbox checked disabled />}
                              label=""
                            />
                          </FormGroup>
                          TO BE PRINTED
                        </>
                      ) : (
                        <>
                          <FormGroup>
                            <FormControlLabel
                              control={<Checkbox  disabled />}
                              label=""
                            />
                          </FormGroup>
                          TO BE PRINTED
                        </>
                      )}
                    </p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <p className="tFormlabel checkAndTextAlign">
                      {rowData?.voucher === "T" ? (
                        <>
                          <FormGroup>
                            <FormControlLabel
                              control={<Checkbox checked disabled />}
                              label=""
                            />
                          </FormGroup>
                          VOUCHER
                        </>
                      ) : (
                        <>
                          <FormGroup>
                            <FormControlLabel
                              control={<Checkbox disabled  />}
                              label=""
                            />
                          </FormGroup>
                          VOUCHER
                        </>
                      )}
                    </p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">PC/PROJECT</p>
                <p className="tFormName">{rowData?.pc_project}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">BALANCE</p>
                <p className="tFormName">{rowData?.balance}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">EXCHANGE RATE</p>
                <p className="tFormName">{rowData?.exchangerate}</p>
              </Grid>

              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">CHECK #</p>
                <p className="tFormName">{rowData?.tranid}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">PAYEE</p>
                <p className="tFormName">{rowData?.payee}</p>
              </Grid>

              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <Grid container>
                  <Grid item xs={12} sm={6} md={6}>
                    <p className="tFormlabel">DATE</p>
                    <p className="tFormName">{rowData?.date}</p>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6}>
                    <p className="tFormlabel">voided On</p>
                    <p className="tFormName">{rowData?.voided_on}</p>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">MEMO</p>
                <p className="tFormName">{rowData?.memo}</p>
              </Grid>
            </Grid>
          </>
          {/* ))} */}
        </Box>
      </Box>

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((d, i) => ( */}
          <>
            <Grid container className="mb-2">
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">SUBSIDIARY</p>
                <p className="tFormName">{rowData?.subsidiary}</p>
              </Grid>

              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">DEPARTMENT</p>
                <p className="tFormName">{rowData?.department}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">SERVICE LINE</p>
                <p className="tFormName">{rowData?.service_line}</p>
              </Grid>
              {/* <Grid item xs={12} sm={12} md={8} className="m-b-10"></Grid> */}
              <Grid item xs={12} sm={6} md={6} className="m-b-10">
                <p className="tFormlabel">LOCATION</p>
                <p className="tFormName">{rowData?.location}</p>
              </Grid>
            </Grid>
          </>
          {/* ))} */}
        </Box>
      </Box>

      <Box>
        <Box
          className="viewBox "
          // sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Apply" />
            <Tab label="Payee Address" />
            <Tab label="Relationships" />
            <Tab label="Communication" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
            <Tab label="J.P.Morgan" />
          </Tabs>

          {/*Apply*/}
          <TabPanel value={tabIndex} index={0}>
            <BillPaymentApply />
          </TabPanel>
          {/*Apply*/}

          {/* Payee Address */}
          <TabPanel value={tabIndex} index={1}>
            <Box className="viewDetilsBox">
              {/* {payeeAddData?.map((d, i) => ( */}
                <>
                  <Grid container className="mb-2">
                    <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel">PAY TO</p>
                      <p className="tFormName">
                        {payeeAddData?.vendor} <span className="tFormlabel">Map</span>
                      </p>
                    </Grid>
                  </Grid>
                </>
            
            </Box>
          </TabPanel>
          {/* Payee Address */}

          {/* Relationship */}
          <TabPanel value={tabIndex} index={2}>
          {tabIndex === 2 &&  <BillPaymentRelationship tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Relationship */}

          {/* Communication */}
          <TabPanel value={tabIndex} index={3}>
          {tabIndex === 3 && <BillPaymentCommunication tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Communication */}

          {/* SystemInformation */}
          <TabPanel value={tabIndex} index={4}>
            {tabIndex === 4 && (
              <BillPaymentSystemInformation tabIndexP={tabIndex} />
            )}
          </TabPanel>
          {/* SystemInformation */}

          {/* Custom */}
          <TabPanel value={tabIndex} index={5}>
          {tabIndex === 5 &&   <BillPaymentCustom tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Custom */}

          {/* Eft */}
          <TabPanel value={tabIndex} index={6}>
          {tabIndex === 6 &&  <BillPaymentEft tabIndexP={tabIndex} />}
          </TabPanel>
          {/* jp morgan */}

          <TabPanel value={tabIndex} index={7}>
            <Box className="viewDetilsBox">
              {/* {tax_R_Data?.map((el, index) => (
              <Box className="viewDetilsBox" key={index}> */}
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN REFERENCE ID</p>
                  <p className="tFormName">{jpMorganData?.reference_id}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN STATUS</p>
                  <p className="tFormName">{jpMorganData?.status}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN MESSAGE</p>
                  <p className="tFormName">{jpMorganData?.message}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN UPDATED DATE</p>
                  <p className="tFormName">{jpMorganData?.updated_date}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN PAYER</p>
                  <p className="tFormName">{jpMorganData?.payer}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN TRANSACTION ID</p>
                  <p className="tFormName">{jpMorganData?.transaction_id}</p>
                </Grid>
              </Grid>
            </Box>
            {/* ))} */}
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
